import * as React from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import SimpleCurrencyInput from "react-simple-currency";
import { GenericInputHeader } from "./GenericInputHeader";
import { Globals } from "../../Globals";

interface GenericDollarInputProps {
    hrDollarQuestionWithStatus: HRQuestionWithStatus<HRQuestion.DollarQuestion>;
    isHidden: boolean;
    onChange: (newVal: string, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericDollarInput extends React.Component<GenericDollarInputProps> {
    constructor(props: GenericDollarInputProps) {
        super(props);
        if (props.hrDollarQuestionWithStatus.question.answer !== null) {
            return;
        }

        // There's an issue here where setting the value counts as change, so it saves 0 to default val
        const lastPick = Globals.getAnswerByTemplateId(props.hrDollarQuestionWithStatus.question.textId);
        if (lastPick !== null) {
            this.props.onChange(lastPick, props.hrDollarQuestionWithStatus.question.id);
            this.props.onBlur(props.hrDollarQuestionWithStatus.question.id);
        }
    }

    handleCurrencyValueChange = (raw: any, questionId: HRQuestionId, _masked: any) => {
        const answer = (parseInt(raw, 10) / 100).toFixed(2) + 0;
        this.props.onChange(answer.toString(), questionId);
    }

    parseForComponentNumber = (num: string): number => {
        return Number((parseFloat(num) * 100).toFixed(2));
    }

    render() {
        const question = this.props.hrDollarQuestionWithStatus.question;
        const status = this.props.hrDollarQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <SimpleCurrencyInput
                    precision={2}
                    separator="."
                    delimiter=","
                    unit="$"
                    allowNegative={false}
                    required={question.isMandatory}
                    id={HRQuestionId.unwrap(question.id).toString()}
                    className={"form-control"}
                    onInputChange={(raw: any, _masked: any) => this.handleCurrencyValueChange(raw, question.id, _masked)}
                    value={question.answer === null ? undefined : this.parseForComponentNumber(question.answer)}
                    onInputBlur={() => this.props.onBlur(question.id)}
                />
            </div>);

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericDollarInput.tsx